import { ReactChild } from "react";
import { CompartilhamentoProvider } from "../../context/CompartilhamentoContext";
import { ConsentimentoProvider } from "../../context/ConsentimentoContext";
import { ModalProvider } from "../../context/ModalContext";
import AuthContextProvider from "../../context/AuthContext";
import { ConsentimentoRecorrenteProvider } from "../../context/RecorrenteContext";
import { TransferenciaInteligenteProvider } from "../../context/TransferenciaInteligenteContext";
import { AutomaticoProvider } from "../../context/AutomaticoContext";

interface Props {
    children: ReactChild;
}

export function Providers ({ children }: Props) {
    
    return (
        <AuthContextProvider>
            <CompartilhamentoProvider>
                <ConsentimentoProvider>
                    <ConsentimentoRecorrenteProvider>
                        <TransferenciaInteligenteProvider>
                            <AutomaticoProvider>
                                <ModalProvider>
                                    {children}
                                </ModalProvider>
                            </AutomaticoProvider>
                        </TransferenciaInteligenteProvider>
                    </ConsentimentoRecorrenteProvider>
                </ConsentimentoProvider>
            </CompartilhamentoProvider>
        </AuthContextProvider>
    );
}